import { render, staticRenderFns } from "./PrintPuzzleGrid.vue?vue&type=template&id=0d158392&scoped=true&"
import script from "./PrintPuzzleGrid.vue?vue&type=script&lang=ts&"
export * from "./PrintPuzzleGrid.vue?vue&type=script&lang=ts&"
import style0 from "./PrintPuzzleGrid.vue?vue&type=style&index=0&id=0d158392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d158392",
  null
  
)

export default component.exports